import { render } from "./DeviceCreateComponent.vue?vue&type=template&id=0c16127c&scoped=true"
import script from "./DeviceCreateComponent.vue?vue&type=script&lang=js"
export * from "./DeviceCreateComponent.vue?vue&type=script&lang=js"

import "./DeviceCreateComponent.vue?vue&type=style&index=0&id=0c16127c&scoped=true&lang=css"

import exportComponent from "/Users/dmitriy-pc/Projects/docs.d-services.ru/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c16127c"]])

export default __exports__